import { useState, useEffect, memo } from "react"
import { DateRangePicker, SelectPicker, Input, TagPicker, MultiCascader } from 'rsuite';
import Dropdown from 'rsuite/Dropdown';
import { startOfDay, endOfDay, addDays, startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfYear, endOfYear } from "date-fns";
import { Link } from "react-router-dom"
import { Row, Col } from "react-bootstrap"
import axiosService from "../../../utils/axios.service";
import { format } from "date-fns"
import { Button } from 'antd';
import 'antd/dist/antd.min.css'
import { headerReport } from "../../../enums/headerReport.enum";
import { CSVDownload } from "react-csv";
import * as convert from "../../constant/Convert.helper";
import _ from "lodash";
import StorageService from "../../../utils/storage.service";

const FilterReport = ({ startDate, endDate, handleRangeDate, store, handleStore, handleSearchVoucher, sortBy, handleSortBy, typeBHVV, setTypeBHVV, title, type, isExport, csvData, 
    handleExportData, header, fileName, userAdmin, onChangeKeyword, startOldDate,  endOldDate, handleRangeDateOld, optionCategory, handleCategory ,handleExportHd, selectListUser, channel, handleChannel}) => {
    
    const [locations, setLocations] = useState([])
    const [locationsWidth, setLocationsWidth] = useState(window.innerWidth)
    const [users, setUsers] = useState([])
    const [valueSelect, setValueSelect] = useState([])
    const userInfo = JSON.parse(StorageService.getItem("user_info"));


    const sortByList = ['Ngày', "Tuần", 'Tháng'].map(
        (x, i) => ({ label: x, value: i })
    )

    const sortByBHVV = ['Tất cả', "Head Office",  "Cơ sở"].map(
        (x, i) => ({ label: x, value: i })
    )

    const channelOptions = [
        { label: "Tất cả", value: "all" },
        { label: "Online", value: "online" },
        { label: "Offline", value: "offline" },
    ]

    const [sortByListBooking, setSortByListBooking] = useState(['Ngày', "Tuần", 'Tháng'].map(
        (x, i) => ({ label: x, value: i })
    ))
    
    const [keyword, setKeyword] = useState('')
    let startOfWeek1 = startOfWeek(new Date())
    let endOfWeek1 = endOfWeek(new Date())

    let ranges = [
        {
            label: "Hôm qua",
            value: [
                startOfDay(addDays(new Date(), -1)),
                endOfDay(addDays(new Date(), -1)),
            ],
        },
        {
            label: "Hôm nay",
            value: [startOfDay(new Date()), endOfDay(new Date())],
        },
        {
            label: "Tuần này",
            value: [addDays(startOfWeek1, 1), addDays(endOfWeek1, 1)],
        },
        {
            label: "Tuần trước",
            value: [addDays(startOfWeek(addDays(startOfWeek1, -1)), 1), addDays(endOfWeek(addDays(startOfWeek1, -1)), 1)],
        },
        {
            label: "Tháng này",
            value: [startOfMonth(new Date()), endOfMonth(new Date())],
        },
        {
            label: "Tháng trước",
            value: [startOfMonth(addDays(startOfMonth(new Date()), -1)), endOfMonth(addDays(startOfMonth(new Date()), -1))],
        },
        {
            label: "Năm này",
            value: [startOfYear(new Date()), endOfDay(endOfYear(new Date()))],
        },
        {
            label: "Năm trước",
            value: [startOfYear(addDays(startOfYear(new Date()), -1)), endOfYear(addDays(startOfYear(new Date()), -1))],
        },
    ]
    let rangesNv = [
        {
            label: "Hôm qua",
            value: [
                startOfDay(addDays(new Date(), -1)),
                endOfDay(addDays(new Date(), -1)),
            ],
        },
        {
            label: "Hôm nay",
            value: [startOfDay(new Date()), endOfDay(new Date())],
        },
        {
            label: "Tuần này",
            value: [addDays(startOfWeek1, 1), addDays(endOfWeek1, 1)],
        },
        {
            label: "Tuần trước",
            value: [addDays(startOfWeek(addDays(startOfWeek1, -1)), 1), addDays(endOfWeek(addDays(startOfWeek1, -1)), 1)],
        },
        {
            label: "Tháng này",
            value: [startOfMonth(new Date()), endOfMonth(new Date())],
        },
        {
            label: "Tháng trước",
            value: [startOfMonth(addDays(startOfMonth(new Date()), -1)), endOfMonth(addDays(startOfMonth(new Date()), -1))],
        },
    ]

    useEffect(() => {
        if (["package-using-store", "operate-booking", "daily", "locations","projected-revenue", "report-rating", "ktv-tvv-detail",  "customers", "cashiers", "users", "products", 
            "sales", "report-detail-service", "total-sales-online", "ktv-tvv", "detail-ktv-tvv", "report-chua-phuc-vu", "cash-flow", "bhvv-flow", "customer-course", "customer-new", "upsale", "expected-cash", "debt-collection", "purchase-behavior"].includes(type)) {
            fetchLocations()
        }
        if (type == 'detail_promotion') {
            fetchGroupVoucher()
        }

        if (type == 'ktv-tvv-detail') {
            fetchUsers()
        }
    }, [sortBy])

    useEffect(() => {
        let check = String(store).split(',')
        let data = []
        for(let item of check) {
            data.push(Number(item))
        }
        setValueSelect([...data])
    }, [store])

    const onChangeDate = (e) => {
        if (e) {
            const eDate = format(e[1], 'yyyy-MM-dd')
            const sDate = format(e[0], 'yyyy-MM-dd')
            handleRangeDate(sDate, eDate)
        }
    }

    const onChangeDateOld = (e) => {
        if (e) {
            const eDate = format(e[1], 'yyyy-MM-dd')
            const sDate = format(e[0], 'yyyy-MM-dd')
            handleRangeDateOld(sDate, eDate)
        }
    }

    const onChangeCategory = (e) =>{
        handleCategory(e)
    }

    const fetchLocations = async () => {
        if (userAdmin && ![1,8].includes(userAdmin.role)) {
            let dataStore = convert.getStoreByRole(userAdmin)
            setLocations([...dataStore])
        } else {
            const rs = await axiosService("api/stores", "GET")
            const { data } = rs
            if (data.code === 200) {
                data.data.unshift({ name_store: "Tất cả", id: 0 })
                const newLocations = data.data.map(x => {
                    return { label: x.name_store, value: x.id }
                })
                setLocations([...newLocations])
            }
        }
    }

    const fetchGroupVoucher = async () => {
        const rs = await axiosService("api/category_voucher", "GET")
        const { data } = rs
        if (data.code === 200) {
            data.data.unshift({ group_name: "Tất cả", id: 0 })
            const newLocations = data.data.map(x => {
                return { label: x.group_name, value: x.id }
            })
            setLocations([...newLocations])
        }
    }

    const fetchUsers = async() => {
        const rs = await axiosService("api/users", "GET")
        const { data } = rs
        if (data.code === 200) {
            const newLocations = data.data.map(x => {
                return { label: x.name, value: x.id }
            })
            setUsers([...newLocations])
        }
    }

    const onChangeSortBy = (e) => {
        handleSortBy(e)
    }
    const onChangeVoucherName = _.debounce((e) => {
        if (e.length > 3) {
            handleSearchVoucher(e)
        }
    }, 1000)

    const onChangeKeywordHeader = _.debounce((e) => {
        setKeyword(e)
        onChangeKeyword(e)
    }, 1000)

    const onChangeStore = (e) => {
        handleStore(e)
    }

    const onCheck = _.debounce((selectedValues, selectedItem) => {
        const allStoreIds = locations.map(item => Number(item.value));
        if (selectedItem.value === 0) {
            if (selectedValues.includes(0)) {
                handleStore(allStoreIds);
            } else {
                const savedStore = parseInt(StorageService.getItem("currentStore"));
                const ownStoreIds = (userInfo?.stores || []).map((item) => Number(item.id));
                const currentStore = userInfo?.role === 3 && !ownStoreIds.includes(savedStore)
                    ? userInfo?.stores?.[0]?.id
                    : savedStore;
                handleStore([currentStore]);
            }
        } else {
            handleStore(selectedValues);
        }
    }, 1000)

    const onChangeUser = (e) => {
        selectListUser(e)
    }
   
    return (
        <div className="search-report">
            <Row>
                {isExport && <CSVDownload data={csvData} headers={header} filename={fileName} target="_blank" />}
                {type != 'detail-ktv-tvv' && 
                    <Col xs={12} md={3} className="mb-2">
                        {userInfo.role === 1 ? 
                            locationsWidth > 765 ?
                                //Menu link report
                                <Dropdown title={title} trigger="click">
                                    {headerReport.map((x, i) => (
                                        <Dropdown.Item as={Link} to={{ pathname: `/report/${x.route}` }} key={i}>
                                            <i className={`${x.icon} mr-1`} />
                                            <span>{x.label}</span>
                                            {title === x.label && <i className="ml-2 fa-solid fa-check" />}
                                        </Dropdown.Item>                                    
                                    ))}
                                </Dropdown>
                            :
                                <Row>
                                    <Col xs={6}>
                                        <Dropdown title={title} trigger="click">
                                            {headerReport.map((x, i) => {
                                                return (
                                                    <Link to={{ pathname: `/report/${x.route}` }} key={i}>
                                                        <Dropdown.Item>
                                                            <i className={`${x.icon} mr-1`}></i>
                                                            <span>{x.label}</span>
                                                            {type === x.route && <i className="ml-2 fa-solid fa-check"></i>}
                                                        </Dropdown.Item>
                                                    </Link>
                                                )
                                            })}
                                        </Dropdown>
                                    </Col>

                                    {/* Select option store */}
                                    {["cash-flow", "bhvv-flow", "operate-booking", "booking", "ktv-tvv-detail", "customers", "cashiers", "users", "products", "sales", "report-detail-service", "ktv-tvv", "detail_promotion", "total-sales-online", "report-chua-phuc-vu", "customer-course", "customer-new", "upsale", "expected-cash", "debt-collection", "purchase-behavior"].includes(type) &&
                                        <Col xs={6}>
                                            <SelectPicker data={locations} className="w-100" defaultValue={store} onChange={onChangeStore} />
                                        </Col>
                                    }
                                    {["customer-course", "customer-new"].includes(type) &&
                                        <Col xs={6}>
                                            <SelectPicker data={channelOptions} className="w-100" value={channel || "all"} onChange={(value) => handleChannel(value || "all")} cleanable={false} />
                                        </Col>
                                    }
                                    {/* Multi select store */}
                                    {["daily", "locations", "projected-revenue", "report-rating"].includes(type) &&
                                        <Col xs={6} className="mb-2">
                                            <MultiCascader
                                                data={locations}
                                                className="w-100 style-multi-cas"
                                                defaultValue={[...valueSelect]}
                                                value={[...valueSelect]}
                                                onCheck={onCheck}
                                                placement={"bottomEnd"}
                                            />
                                        </Col>
                                    }
                            </Row>
                        :null}
                       
                   </Col>
                }
                <Col xs={12} md={9}>
                    {locationsWidth > 765 ?
                        <Row className="justify-content-end">
                            {type == "ktv-tvv-detail" &&
                                <Col sm={3} xs={type != 'detail-ktv-tvv' || type != 'locations'  ? 6 : 10}>
                                    <DateRangePicker
                                      className="w-100"
                                      placement={"bottomEnd"}
                                      format="yyyy-MM-dd"
                                      onChange={onChangeDateOld}
                                      ranges={type != 'detail-ktv-tvv' ? ranges : rangesNv}
                                      showOneCalendar={true}
                                      defaultValue={[new Date(startOldDate), new Date(endOldDate)]}
                                      value={[new Date(startOldDate), new Date(endOldDate)]}
                                    />
                                </Col>
                            }
                            {type == "ktv-tvv-detail" &&
                                <Col sm={2} xs={type != 'detail-ktv-tvv' || type != 'locations'  ? 6 : 10}>
                                    <TagPicker
                                        data={users} 
                                        className="w-100 list-users"
                                        placeholder="Nhân viên"
                                        onChange={onChangeUser}
                                    />
                                </Col>
                            }
                            
                            {["daily", "locations", "projected-revenue", "report-rating"].includes(type) &&
                                <Col xs={3} className="mb-2">
                                    <MultiCascader
                                        data={locations}    
                                        className="w-100 style-multi-cas"
                                        defaultValue={[...valueSelect]}
                                        value={[...valueSelect]}
                                        onCheck={onCheck}
                                        placement={"bottomEnd"}
                                    />
                                </Col>
                            }
                            {["package-using-store", "cash-flow", "bhvv-flow", "operate-booking", "booking", "ktv-tvv-detail", "customers", "cashiers", "users", 
                            "products", "sales", "report-detail-service", "ktv-tvv", "detail_promotion", "total-sales-online", "report-chua-phuc-vu", "customer-course", "customer-new", "upsale", "expected-cash", "debt-collection", "purchase-behavior"].includes(type) &&
                                <Col xs={type == "ktv-tvv-detail" || type == "report-detail-service" ? 2: 3}  className="mb-2">
                                    <SelectPicker
                                        data={locations} 
                                        className="w-100" 
                                        defaultValue={store}
                                        onChange={onChangeStore}
                                    />
                                </Col>
                            }
                            {(type === "report-detail-service") &&
                                <Col xs={2}>
                                    <SelectPicker data={optionCategory} className="w-100" defaultValue={0} onChange={onChangeCategory} />
                                </Col>
                            }
                            {(["daily", "locations", "report-detail-service", "report-chua-phuc-vu"].includes(type)) && (userAdmin.role === 1) &&
                                <Col xs={2} className="mb-2">
                                    <SelectPicker data={sortByBHVV} className="w-100" defaultValue={typeBHVV} onChange={setTypeBHVV} />
                                </Col>
                            }
                            {["customer-course", "customer-new"].includes(type) &&
                                <Col xs={2} className="mb-2">
                                    <SelectPicker data={channelOptions} className="w-100" value={channel || "all"} onChange={(value) => handleChannel(value || "all")} cleanable={false} />
                                </Col>
                            }

                            {["daily", "projected-revenue"].includes(type) &&
                                <Col xs={2} className="mb-2">
                                    <SelectPicker data={sortByList} className="w-100" defaultValue={sortBy} onChange={onChangeSortBy} />
                                </Col>
                            }

                            {type === "booking" &&
                                <Col xs={2} className="mb-2">
                                    <SelectPicker data={sortByListBooking} className="w-100" defaultValue={sortBy} onChange={onChangeSortBy} />
                                </Col>
                            }
                            {type === "detail_promotion" &&
                                <Col xs={6} md={2}  className="mb-2">
                                    <Input data={sortByList} placeholder="Chi tiết mã" className="w-100" onChange={onChangeVoucherName} />
                                </Col>
                            }

                            {(type == "sales" || type == "report-detail-service" || type == "ktv-tvv" || type == "count_package_customer") &&
                                <Col xs={3}  className="mb-2">
                                    <Input data={keyword} placeholder="Tìm kiếm theo keyword" className="w-200" onChange={onChangeKeywordHeader} />
                                </Col>
                            }

                            {type != 'detail-ktv-tvv' && type != 'report-chua-phuc-vu' &&
                                <Col xs={type != 'detail-ktv-tvv' ? 3 : 5}  className="mb-2">
                                    <DateRangePicker
                                        className="w-100"
                                        placement={"bottomEnd"}
                                        format="yyyy-MM-dd"
                                        onChange={onChangeDate}
                                        ranges={type != 'detail-ktv-tvv' ? ranges : rangesNv}
                                        defaultValue={[new Date(startDate), new Date(endDate)]}
                                    />
                                </Col>
                            }

                            {!['cent-office', 'cash-flow', 'bhvv-flow', 'detail-ktv-tvv', 'ktv-tvv-detail', 'customer-course', 'customer-new', 'upsale', 'expected-cash', 'debt-collection', 'purchase-behavior'].includes(type) &&
                                <Col xs={2} style={{ textAlign: "right" }}  className="mb-2">
                                    <Button size="middle" type="primary" onClick={handleExportData}>
                                        <i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                                    </Button>
                                </Col>
                            }
                            {type == 'detail_promotion' &&
                                <Col xs={2} style={{ textAlign: "right" }}  className="mb-2">
                                    <Button size="middle" type="primary" onClick={() => handleExportHd()}>
                                        <i className="fa-solid fa-file-excel mr-2"></i>Xuất hoá đơn
                                    </Button>
                                </Col>
                            }
                        </Row>
                    :
                        <Row>
                            {type == "ktv-tvv-detail" &&
                                <Col sm={3} xs={type != 'detail-ktv-tvv' || type != 'locations'  ? 6 : 10}>
                                    <DateRangePicker
                                        className="w-100"
                                        placement={"bottomEnd"}
                                        format="yyyy-MM-dd"
                                        onChange={onChangeDateOld}
                                        ranges={type != 'detail-ktv-tvv' ? ranges : rangesNv}
                                        style={{width: 350}}
                                        showOneCalendar={true}
                                        defaultValue={[new Date(startOldDate), new Date(endOldDate)]}
                                        value={[new Date(startOldDate), new Date(endOldDate)]}
                                    />
                                </Col>
                            }
                            {(["daily", "locations", "report-detail-service", "report-chua-phuc-vu"].includes(type)) && (userAdmin.role === 1) &&
                                <Col xs={6} className="mb-2">
                                    <SelectPicker data={sortByBHVV} className="w-100" defaultValue={typeBHVV} onChange={setTypeBHVV} />
                                </Col>
                            }
                            
                            {["daily", "ktv-tvv-detail", "projected-revenue"].includes(type) &&
                                <Col xs={6}>
                                    <SelectPicker data={sortByList} className="w-100" defaultValue={sortBy} onChange={onChangeSortBy} />
                                </Col>
                            }
                            {type === "booking" &&
                                <Col xs={5}>
                                    <SelectPicker data={sortByList} className="w-100" defaultValue={sortBy} onChange={onChangeSortBy} />
                                </Col>
                            }
                            {type === "detail_promotion" &&
                                <Col xs={4} md= {2}>
                                    <Input data={sortByList} placeholder="Chi tiết mã" className="w-100" onChange={onChangeVoucherName} />
                                </Col>
                            }
                            {(type === "report-detail-service") &&
                                <Col xs={12}>
                                    <SelectPicker data={optionCategory} className="w-100" defaultValue={optionCategory[0]?.value} onChange={onChangeCategory} />
                                </Col>
                            }
                            {(type == "sales" || type == "ktv-tvv" || type == "report-detail-service") &&
                                <Col sm={4} xs={6}>
                                    <Input data={keyword} placeholder="Tìm kiếm theo keyword" className="w-200" onChange={onChangeKeywordHeader} />
                                </Col>
                            }
                            {type != "report-chua-phuc-vu" &&
                                <Col sm={4} xs={type != 'detail-ktv-tvv' || type != 'locations'  ? 6 : 10}>
                                    <DateRangePicker
                                        className="w-100"
                                        placement={"bottomEnd"}
                                        format="yyyy-MM-dd"
                                        onChange={onChangeDate}
                                        ranges={type != 'detail-ktv-tvv' ? ranges : rangesNv}

                                        style={{width: 350}}
                                        showOneCalendar={true}
                                        defaultValue={[new Date(startDate), new Date(endDate)]}
                                    />
                                </Col>
                            }
                            
                            {!['cent-office', 'cash-flow', 'detail-ktv-tvv', 'ktv-tvv-detail', 'bhvv-flow'].includes(type) &&
                                <Col sm={3} xs={12} style={{ textAlign: "right" }} className="mt-2">
                                    <Button size="middle" type="primary" onClick={() => handleExportData}><i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu</Button>
                                </Col>
                            }
                            {type == 'detail_promotion' &&
                                <Col sm={3} xs={12} style={{ textAlign: "right" }} className="mb-2">
                                    <Button size="middle" type="primary" onClick={() => handleExportHd()}><i className="fa-solid fa-file-excel mr-2"></i>Xuất hoá đơn</Button>
                                </Col>
                            }
                        </Row>
                    }
                </Col>
            </Row>
        </div>
    )
}
export default memo(FilterReport)